import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-layout-register-client',
  templateUrl: './layout-register-client.component.html',
  styleUrls: ['./layout-register-client.component.scss']
})
export class LayoutRegisterClientComponent implements OnInit {

  currentStep: number;

  constructor() { 
    this.currentStep = 1;
  }

  ngOnInit(): void {
  }

  backForm() {
    this.currentStep --;
  }

  changeForm(event: number) {
    this.currentStep = event
  }
}
